module.exports = __webpack_public_path__ + "images/emoji/european_castle.2338bcf9d813c3f3f4f3.png";